import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-choose-us',
  templateUrl: './why-choose-us.component.html',
  styleUrls: ['./why-choose-us.component.scss']
})
export class WhyChooseUSComponent implements OnInit {
  firstfeatures = [
    { icon: 'assets/img/live-courses/live.png', title: 'Live Interactive Sessions', desc: 'Engage in real-time learning with expert instructors' },
    { icon: 'assets/img/live-courses/mentor.png', title: 'Mentors from Top Product Company', desc: 'Learn from industry professionals with proven expertise' },
    { icon: 'assets/img/live-courses/certificate.png', title: 'Certificate of Completion', desc: 'Earn recognized certification for your achievements' },
    { icon: 'assets/img/live-courses/career-service.png', title: 'Career Services', desc: 'Get personalized guidance for career advancement' },

  ];

  secondfeatures = [
    { icon: 'assets/img/live-courses/curriculum.png', title: 'Curriculum by Industry Experts', desc: 'Comprehensive learning path designed by professionals' },
    { icon: 'assets/img/live-courses/platform.png', title: 'Platform to Practice', desc: 'Hands-on coding environment for real-world practice' },
    { icon: 'assets/img/live-courses/gallery.png', title: 'Gallery of Learning Notes', desc: 'Access comprehensive study materials and resources' },
    { icon: 'assets/img/live-courses/doubt.png', title: 'Doubt Resolution', desc: 'Get your questions answered by expert mentors' },

  ];

  @Input() link!: string;
  constructor() { }

  ngOnInit(): void {
  }

}
